import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133e0259"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "pincode",
  class: "body flex-mid"
}
const _hoisted_2 = { class: "card create-account" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-32 fw-600",
  style: {"margin-bottom":"4.6rem"}
}, "My Culture", -1))
const _hoisted_4 = { class: "fw-900 fs-18" }
const _hoisted_5 = {
  class: "flex-center mt-24",
  style: {"justify-content":"space-between"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-30 fw-700 pb-3" }, "-", -1))
const _hoisted_7 = { class: "center fs-14 mt-32" }
const _hoisted_8 = { class: "link-text ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("pincode.Enter_your_PIN_code")) + " " + _toDisplayString(_ctx.email), 1),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otp.one) = $event)),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPOne && _ctx.checkedOTPOne(...args))),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_one",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.one]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otp.two) = $event)),
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPTwo && _ctx.checkedOTPTwo(...args))),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_two",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.two]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otp.three) = $event)),
          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPThree && _ctx.checkedOTPThree(...args))),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_three",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.three]
        ]),
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otp.four) = $event)),
          onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPFour && _ctx.checkedOTPFour(...args))),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_four",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.four]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.otp.five) = $event)),
          onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPFive && _ctx.checkedOTPFive(...args))),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_five",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.five]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.otp.six) = $event)),
          onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPSix && _ctx.checkedOTPSix(...args))),
          onKeyup: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.continueFunc && _ctx.continueFunc(...args)), ["enter"])),
          class: _normalizeClass([{ warning: _ctx.otpWarning }, "input-pincode"]),
          ref: "input_otp_six",
          type: "number",
          inputmode: "decimal",
          pattern: "[0-9]*"
        }, null, 34), [
          [_vModelText, _ctx.otp.six]
        ])
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.error) + " ", 1),
      _createElementVNode("div", {
        class: "btn-create btn-primary flex-mid mt-40",
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.continueFunc && _ctx.continueFunc(...args)))
      }, " Continue "),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("pincode.Sign_in_using_a")), 1)
      ])
    ])
  ]))
}